import React from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";

const LANGUAGE_OPTIONS = [
  { value: "EN", label: "English" },
  { value: "TH", label: "Thai" },
  { value: "ZH", label: "Chinese" },
  { value: "MS", label: "Malay" },
];

export const ExportButtons = ({
  handleExport,
  isExporting,
  exportingType,
  data,
  error,
  additionalInfoFields = [],
  exportLang = "EN",
  setExportLang,
}) => {
  const isDisabled = isExporting || !data.length || !!error;
  const hasAdditionalInfoFields = additionalInfoFields.length > 0;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      flexWrap="wrap"
      sx={{
        p: 2,
        borderBottom: "1px solid #E5E7EB",
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="subtitle1" fontWeight="bold">
        Export as:
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ minWidth: 100 }}
        onClick={() => handleExport("csv")}
        disabled={isDisabled}
        startIcon={
          isExporting && exportingType === "csv" ? (
            <CircularProgress size={16} />
          ) : null
        }
      >
        CSV
      </Button>
      <Button
        variant="contained"
        color="primary"
        sx={{ minWidth: 100 }}
        onClick={() => handleExport("excel")}
        disabled={isDisabled}
        startIcon={
          isExporting && exportingType === "excel" ? (
            <CircularProgress size={16} />
          ) : null
        }
      >
        EXCEL
      </Button>
      <Button
        variant="contained"
        color="primary"
        sx={{ minWidth: 100 }}
        onClick={() => handleExport("txt")}
        disabled={isDisabled}
        startIcon={
          isExporting && exportingType === "txt" ? (
            <CircularProgress size={16} />
          ) : null
        }
      >
        TXT
      </Button>

      {hasAdditionalInfoFields && (
        <>
          <Box sx={{ width: "1px", height: "24px", backgroundColor: "#E5E7EB" }} />
          <Typography variant="body2" color="text.secondary">
            Additional Info Language:
          </Typography>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              value={exportLang}
              onChange={(e) => setExportLang?.(e.target.value)}
              disabled={isExporting}
              sx={{
                "& .MuiSelect-select": {
                  py: 0.75,
                },
              }}
            >
              {LANGUAGE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}
    </Box>
  );
};
